module.exports = __webpack_public_path__ + "img/1485436608.32879f54.jpg";